<template>
  <b-row class="w-100 m-0">
    <b-col class="p-0 col-12 col-lg-8">
      <div class="talent-details-card" @click="$emit('edit_proposal', 'talent_details')">
        <b-avatar :src="avatar" size="56" class="mr-1" />
        <div class="overflow-hidden">
          <p class="mb-0 avenir-bold talent-name">{{ full_name || 'Sin nombre' }}</p>
          <small class="text-muted">{{ details.email }}</small>
        </div>
        <div class="background-button-edit box-edit">
          <h5 class="m-0 animation-opacity-words">Editar detalles del talento</h5>
        </div>
      </div>
    </b-col>
    <b-col class="d-none d-lg-block col-4 p-0 pl-2">
      <div class="bubble-edit" @click="$emit('edit_proposal', 'talent_details')">
        <feather-icon icon="Edit2Icon"></feather-icon>
        <span class="ml-05 avenir-bold">Detalles del talento</span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BAvatar } from 'bootstrap-vue'
import { verifyAsset } from '@/libs/utils/urls'

export default {
  name: 'TalentDetailsPreview',
  components: { BRow, BCol, BAvatar },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {
    full_name() {
      return [this.details.first_name, this.details.last_name].filter(Boolean).join(' ')
    },
    avatar() {
      return this.details.avatar ? verifyAsset(this.details.avatar) : ''
    },
  },
}
</script>

<style scoped lang="scss">
.talent-details-card {
  position: relative;
  display: flex;
  align-items: center;
  padding: 1em;
  background-color: white;
  border-radius: 0.55em;
  cursor: pointer;
}
.talent-name {
  color: #191919;
  font-size: 1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-edit {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  border-radius: 0.55em;
}
.background-button-edit {
  background-color: transparent;
  transition: all 500ms;
  .animation-opacity-words {
    opacity: 0;
    color: white !important;
    transition: all 500ms;
  }
}
.talent-details-card:hover .background-button-edit {
  background-color: #3b8da888;
  backdrop-filter: blur(10px);
  .animation-opacity-words {
    opacity: 1;
  }
}
.bubble-edit {
  position: relative;
  text-align: left;
  padding: 1em;
  color: #3b8DA8;
  background: #E6f2f6;
  border-radius: 1em;
  cursor: pointer;
}
.bubble-edit:hover {
  transition: all 300ms;
  background: #3b8da82f;
}
.bubble-edit:before {
  border: 10px solid #E6f2f6;
  content: '';
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  transform: rotate(90deg);
  left: -19px;
}
.bubble-edit:hover:before {
  border-top-color: #3b8da82f;
  transition: all 300ms;
}
.ml-05 {
  margin-left: 0.55em;
}
</style>
